interface GitHubMeta {
  repo: string;
  commit: string;
  file: string;
  startLine?: number;
  endLine?: number;
}

/** Extract GitHub metadata from opaque metadata object. Returns null if missing required fields. */
export function extractGitHubMeta(metadata: unknown): GitHubMeta | null {
  if (!metadata || typeof metadata !== 'object') return null;
  const m = metadata as Record<string, unknown>;
  if (typeof m['repo'] !== 'string' || typeof m['commit'] !== 'string' || typeof m['file'] !== 'string') return null;
  return {
    repo: m['repo'],
    commit: m['commit'],
    file: m['file'],
    startLine: typeof m['startLine'] === 'number' ? m['startLine'] : undefined,
    endLine: typeof m['endLine'] === 'number' ? m['endLine'] : undefined,
  };
}

export function buildGitHubUrl(meta: GitHubMeta): string {
  const shortSha = meta.commit.slice(0, 7);
  let url = `https://github.com/${meta.repo}/blob/${shortSha}/${meta.file}`;
  if (meta.startLine != null) {
    url += `#L${meta.startLine}`;
    if (meta.endLine != null && meta.endLine !== meta.startLine) {
      url += `-L${meta.endLine}`;
    }
  }
  return url;
}

/** Format a short display string for the source link. */
export function formatSourceLabel(meta: GitHubMeta): string {
  const shortSha = meta.commit.slice(0, 7);
  const parts = [meta.file, shortSha];
  if (meta.startLine != null) {
    if (meta.endLine != null && meta.endLine !== meta.startLine) {
      parts.push(`Lines ${meta.startLine}-${meta.endLine}`);
    } else {
      parts.push(`Line ${meta.startLine}`);
    }
  }
  return parts.join(' \u00b7 ');
}
